import RichTextWithTitle from 'components/rich-text-with-title/RichTextWithTitle';
import RichText from 'components/rich-text/RichText';

import { ISimpleTabContentSection } from 'source/NFR.types';

const SimpleTabContentSection: React.FC<ISimpleTabContentSection> = ({
  sectionTitle,
  sectionText,
  htmlId,
  subSections
}) => {
  return (
    <div className="tab-content-section">
      {sectionTitle && (
        <h2 id={htmlId} data-epi-type="title" className="tab-content-section-title">
          {sectionTitle}
        </h2>
      )}
      {sectionText && (
        <div className="tab-content-section--text" key={sectionTitle}>
          <RichText {...sectionText} />
        </div>
      )}

      {subSections?.map(
        text =>
          text && (
            <div className="tab-content-section--text" key={text.title}>
              <RichTextWithTitle {...text} />
            </div>
          )
      )}
    </div>
  );
};

SimpleTabContentSection.displayName = 'SimpleTabContentSection';

export default SimpleTabContentSection;
